import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import NoticeTable from './atoms/notice_table';
import { restApi } from '../../apis';

const Notices = (props) => {
  const navigate = useNavigate();
  let num = 1;

  const createExercise = async () => {
    // alert("aa")
    await restApi
    .post('/admin/exercise', {
      categoryId: `6ee75f12-962e-4f8e-aa64-bb1c277c64a1`,
      videoKey: `6ee75f12-962e-4f8e-aa64-bb1c277c64a1`,
      thumnailKey: `6ee75f12-962e-4f8e-aa64-bb1c277c64a1`,
      engName: `exercisetest${num}`,
      korName: `운동테스트${num}`,
      isPublic: 'T',
      time: `exerciseTime${num}`,
      tag1: `exerciseTag1${num}`,
      tag2: `exerciseTag2${num}`,
      tag3: `exerciseTag3${num}`,
      actionDescription: 'test1',
      education: 'test2',
      notice: 'test3',
    })
    .then((res) => {

    })
    .catch((e) => {
      
    });
    num = num + 1;
  }
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        // alignItems: 'center',
        // justifyContent: 'space-between',
      }}
    >
      <button style={{width: '200px', height: '200px'}}          
        onClick={(e) => {
          createExercise()
        }}
      >생성</button>
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '4.6rem',
          alignItems: 'center',
          padding: '0rem 1rem 0rem 1rem',
          background: 'rgba(115, 103, 240, 0.16)',
          border: '1px solid rgba(115, 103, 240, 0.16)',
          borderRadius: '0.6rem',
          // font
          fontFamily: 'Public Sans',
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '1.5rem',
          lineHeight: '2.2rem',
          color: '#7367F0',
        }}
      >
        {`밸런스피터 앱 내에 알리는 공지사항 리스트 입니다.`}
      </div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '100%',
          marginTop: '2.6rem',
          background: '#FFF',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            display: 'flex',
            width: '100%',
            height: '5.6rem',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0rem 2.4rem 0rem 2.4rem',
            // font
            fontFamily: 'Public Sans',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '1.8rem',
            lineHeight: '2.4rem',
          }}
        >
          <div>{`공지사항 리스트`}</div>
          <Button
            type="primary"
            // htmlType={'submit'}
            // loading={loading}
            style={{
              display: 'flex',
              width: '21.3rem',
              height: '3.4rem',
              justifyContent: 'center',
              alignItem: 'center',
              background: '#7367F0',
              // font
              fontWeight: 600,
              fontSize: '1.5rem',
              lineHeight: '2.2rem',
            }}
            onClick={(e) => {
              navigate(`/notices/new`, {
                replace: true,
              });
            }}
          >
            {`새로운 공지사항 생성하기`}
          </Button>
        </div>
        <NoticeTable {...props} />
      </div>
    </div>
  );
};

export default Notices;
